module.exports = "https://s91588.cdn.ngenix.net/news-frontend/_next/static/images/blogs-3146834198274dcadd02c528861672eb.jpg";